var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 13H4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V13H21C21.1978 12.9999 21.391 12.9412 21.5555 12.8314C21.7199 12.7215 21.848 12.5653 21.9237 12.3826C21.9993 12.1999 22.0192 11.9989 21.9806 11.8049C21.942 11.611 21.8468 11.4328 21.707 11.293L12.707 2.29296C12.6142 2.20001 12.504 2.12627 12.3827 2.07596C12.2614 2.02565 12.1313 1.99976 12 1.99976C11.8687 1.99976 11.7386 2.02565 11.6173 2.07596C11.496 2.12627 11.3858 2.20001 11.293 2.29296L2.293 11.293C2.15319 11.4328 2.05798 11.611 2.01942 11.8049C1.98085 11.9989 2.00065 12.1999 2.07632 12.3826C2.15199 12.5653 2.28013 12.7215 2.44454 12.8314C2.60895 12.9412 2.80225 12.9999 3 13ZM10 20V15H14V20H10ZM12 4.41396L18 10.414V15L18.001 20H16V15C16 13.897 15.103 13 14 13H10C8.897 13 8 13.897 8 15V20H6V10.414L12 4.41396Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHome);
export default __webpack_public_path__ + "static/media/bx-home.92821927b865c1a5933b7ea41e91998e.svg";
export { ForwardRef as ReactComponent };